"use client";

import { Box } from "@biom3/react";
import type { PropsWithChildren } from "react";

export function AppToolbarRightSlot({ children }: PropsWithChildren) {
  return <Box testId="AppToolBarRightSlot">{children}</Box>;
}

AppToolbarRightSlot.displayName = "AppToolbar.RightSlot";
